import { createFileRoute, Navigate, redirect } from '@tanstack/react-router';
import { checkUserPermissions } from '@/components/Auth/checkUserPermissions';
import { getDefaultView } from '@/utils/viewHelpers';
import { DocumentHead } from '@/components/core/DocumentHead';
import { useMemo } from 'react';

export const Route = createFileRoute('/$tenantId/_layout/organizations/')({
  component: OrganizationsRedirect,
  beforeLoad: ({ params }) => {
    const hasPermission = checkUserPermissions({
      permission: 'tenant:viewer',
    });
    if (!hasPermission) {
      throw redirect({ to: '/$tenantId', params });
    }
  },
});

function OrganizationsRedirect() {
  const { tenantId } = Route.useParams();
  const view = getDefaultView('organizations');

  const metadataKeys = useMemo(() => {
    switch (view) {
      case 'list':
        return {
          titleKey: 'page.organizations.list.title',
          descriptionKey: 'page.organizations.list.description',
        };
      case 'applications':
        return {
          titleKey: 'page.organizations.applications.title',
          descriptionKey: 'page.organizations.applications.description',
        };
      default:
        return {
          titleKey: 'page.organizations.title',
          descriptionKey: 'page.organizations.description',
        };
    }
  }, [view]);

  return (
    <>
      <DocumentHead
        titleKey={metadataKeys.titleKey}
        descriptionKey={metadataKeys.descriptionKey}
        resetOnUnmount={false}
      />
      <Navigate
        to="/$tenantId/organizations/$view"
        params={{ tenantId, view }}
        replace
      />
    </>
  );
}
